import { AppRoutes } from './routes';
import { Layout } from './components/Layout';

export function App() {
  return (
    <Layout>
      <AppRoutes />
    </Layout>
  );
}
